import { ApiEndpointBuilder } from "@/services/api/types";
import { ProrateResponse } from "../types";
import { TenantTypeEnum } from "@/store/tenants/endpoints/tenants";

const createCheckoutSession = (builder: ApiEndpointBuilder) => {
  return builder.mutation<ProrateResponse, CheckoutRequest>({
    query: request => ({
      url: `/checkout`,
      method: "POST",
      body: request,
    }),
    invalidatesTags: ["currentPlanCheckout"],
  });
};
export default createCheckoutSession;

export interface CheckoutRequest {
  customerAzureObjectId: string;
  checkoutItems: CheckoutItem[];
  referralCode: string;
  isWebsite: true;
  tenantId: string;
  tenantType: TenantTypeEnum;
}

export interface CheckoutItem {
  id: string;
  priceId: string;
  quantity: number;
}
